<template>
  <div class="text-center account-hold-page">
    <br />
    <img
      src="@/assets/AccountOnHold.jpg"
      class="rounded mx-auto d-block h400"
    />
    <br />
    <div class="centerItem">
      <div class="alert alert-success" role="alert">
        <p>"{{ userName }}"<br />Your account is on hold..</p>
        <p>Please, contact your admin for more information!</p>
      </div>
      <br />
    </div>
    <router-link class="btn btn-outline-secondary" :to="{ name: 'Login' }">
      Go Back
    </router-link>
  </div>
</template>

<script>
export default {
  name: "AccountOnHold",
  // props: ["uName"],
  data() {
    return {
      userName: this.$route.params.uName,
    };
  },
};
</script>

<style>
.centerItem {
  /* margin: auto;
  width: 50%;
  padding: 10px; */
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
